var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.52637 6.4V3.2V6.4ZM2.52637 3.2H5.89479H2.52637ZM2.52637 3.2L5.89479 6.4L2.52637 3.2ZM12.6316 6.4V3.2V6.4ZM12.6316 3.2H9.26321H12.6316ZM12.6316 3.2L9.26321 6.4L12.6316 3.2ZM2.52637 9.6V12.8V9.6ZM2.52637 12.8H5.89479H2.52637ZM2.52637 12.8L5.89479 9.6L2.52637 12.8ZM12.6316 12.8L9.26321 9.6L12.6316 12.8ZM12.6316 12.8V9.6V12.8ZM12.6316 12.8H9.26321H12.6316Z",
    fill: "#09090B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52637 6.4V3.2M2.52637 3.2H5.89479M2.52637 3.2L5.89479 6.4M12.6316 6.4V3.2M12.6316 3.2H9.26321M12.6316 3.2L9.26321 6.4M2.52637 9.6V12.8M2.52637 12.8H5.89479M2.52637 12.8L5.89479 9.6M12.6316 12.8L9.26321 9.6M12.6316 12.8V9.6M12.6316 12.8H9.26321",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsExpand);
export default __webpack_public_path__ + "static/media/ArrowsExpand.dfd20d6b94f5e5621f2073f3911d49eb.svg";
export { ForwardRef as ReactComponent };